import { Attributes, NeoModel, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class Address extends ValueObject {

    @Rules.StringLength(100)
    public street: string = "";

    @Rules.StringLength(50)
    public city: string = "";

    @Attributes.Display("State / Province")
    @Rules.StringLength(50)
    public stateProvince: string = "";

    @Rules.StringLength(10)
    public code: string = "";

    public countryId: number | null = null;

    public validateAddress: boolean = false;

    // Client only properties / methods

    public addBusinessRules(rules: Validation.Rules<this>) {
        rules.failWhen(
            c => c.validateAddress && (!c.street || c.street.trim().length === 0),
            "Street is required."
        ).onProperties(c => [c.street, c.validateAddress]);

        rules.failWhen(
            c => c.validateAddress && (!c.city || c.city.trim().length === 0),
            "City is required."
        ).onProperties(c => [c.city, c.validateAddress]);

        rules.failWhen(
            c => c.validateAddress && (!c.code || c.code.trim().length === 0),
            "Code is required."
        ).onProperties(c => [c.code, c.validateAddress]);

        rules.failWhen(
            c => c.validateAddress && (!c.stateProvince || c.stateProvince.trim().length === 0),
            "State / Province is required."
        ).onProperties(c => [c.stateProvince, c.validateAddress]);

        rules.failWhen(
            c => c.validateAddress && c.countryId == null,
            "Country is required."
        ).onProperties(c => [c.countryId, c.validateAddress]);
    }
    
    public toString() {
        if (this.isNew || !this.street) {
            return "New address."
        } else {
            return this.street;
        }
    }
}
